import * as actionTypes from '../actions/actionTypes';

/**
 * @type {UserState}
 */
const initialState = {
  users:[],
  total: 0,
  loading: false,
  error: null,
}

const userReducer = (state = initialState, action) => {
  const stateClone = {
    ...state
  };
  switch (action.type) {
    case actionTypes.FETCH_USERS: {
      stateClone.loading = true;
      break;
    }
    case actionTypes.FETCH_USERS_SUCCESS: {
      stateClone.loading = false;
      stateClone.users = action.payload.users;
      stateClone.total = action.payload.total;
      break;
    }

    case actionTypes.FETCH_USERS_ERROR: {
      stateClone.loading = false;
      stateClone.error = action.payload;
      break;
    }

    case actionTypes.LOGOUT: {
      return initialState;
    }

    default:
      ;
  }
  return stateClone;
};

export default userReducer;
